import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import useOrdenOperations from '../hooks/useOrdenOperations';
import useOrdenComentarios from '../hooks/useOrdenComentarios';
import useFormasPago from '../hooks/useFormasPago';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const OrdenFormaPago = ({
    loadingInfoDetallesOrden,
    orden,
    setOrden,
    seleccionarFormaPago,
    setSeleccionarFormaPago,
    nuevaFormaPago,
    setNuevaFormaPago,
    onComentarioAgregado
}) => {
    const { cambiarFormaPago: cambiarFormaPagoHook } = useOrdenOperations();
    const { guardarComentario } = useOrdenComentarios();
    const { nombreCompleto } = useToken();
    const { formasPago, loading: loadingFormasPago, error: errorFormasPago } = useFormasPago();
    const { showErrorToast, showSuccessToast } = useToast();
    // Manejar error al cargar formas de pago
    React.useEffect(() => {
        if (errorFormasPago) {
            showErrorToast(errorFormasPago);
            
        }
    }, [errorFormasPago]);

    const handleCambiarFormaPago = async () => {
        await cambiarFormaPagoHook(
            orden,
            nuevaFormaPago,
            (data) => {
                const descripcionFormaPago = formasPago.find(fp => fp.vClave === nuevaFormaPago)?.vDescripcionFormaPago;
                
                guardarComentario(
                    orden.idOrden,
                    `<b>${nombreCompleto}</b> cambi&oacute; la forma de pago de la orden de: <b>${orden.vClave} - ${orden.vDescripcionFormaPago}</b> a: <b>${nuevaFormaPago} - ${descripcionFormaPago}</b>`,
                    2,
                    orden,
                    (comentarioBD) => {
                        onComentarioAgregado(comentarioBD);
                    },
                    (error) => {
                        showErrorToast(error);
                        
                    }
                );

                setOrden(prevOrden => ({
                    ...prevOrden,
                    vClave: data.vClave,
                    vDescripcionFormaPago: data.vDescripcionFormaPago,
                    idCatFormaPago: data.idCatFormaPago // Agregado para que SeccionPagos funcione correctamente
                }));

                showSuccessToast("Cambio de forma de pago exitoso");
                setSeleccionarFormaPago(false);
            },
            (error) => {
                showErrorToast(error);
                
                setSeleccionarFormaPago(false);
            }
        );
    };

    return (
        <Col>
            {loadingInfoDetallesOrden ? <Skeleton width={200} /> : <><h5 className="mb-3 fs-0">Forma de pago</h5></>}

            {loadingInfoDetallesOrden ? <Skeleton width={200} /> : <>
                {!seleccionarFormaPago ?
                    <p className="mb-0 fs--1">
                        {orden.vClave == '01' && <img src="/img/efectivo20.png"></img>}
                        {orden.vClave == '03' && <img src="/img/transferencia20.png"></img>}
                        {orden.vClave == '99' && <img src="/img/pordefinir20.png"></img>}
                        {orden.vClave == '28' && <img src="/img/tarjeta20.png"></img>}
                        {orden.vClave == '04' && <img src="/img/tarjeta20.png"></img>}
                        {orden.vClave == '31' && <img src="/img/intermediario20.png"></img>}
                        &nbsp;{orden.vClave}  {orden.vDescripcionFormaPago}&nbsp;&nbsp;
                        <Link to={""} onClick={() => { setSeleccionarFormaPago(true); setNuevaFormaPago(orden.vClave); }}>
                            <img src="/img/editar20.png"></img>
                        </Link>
                    </p>
                    :
                    <>
                        <Form.Group className="mb-3">
                            <Form.Label>Seleccionar Forma de Pago</Form.Label>
                            {loadingFormasPago ? (
                                <Skeleton height={38} />
                            ) : (
                                <Form.Select
                                    value={nuevaFormaPago}
                                    onChange={(e) => setNuevaFormaPago(e.target.value)}
                                >
                                    <option value="">Seleccione una forma de pago</option>
                                    {formasPago.map((fp) => (
                                        <option key={fp.idCatFormaPago} value={fp.vClave}>
                                            {fp.vClave} - {fp.vDescripcionFormaPago}
                                        </option>
                                    ))}
                                </Form.Select>
                            )}
                        </Form.Group>
                        <Button
                            variant="primary"
                            size="sm"
                            onClick={handleCambiarFormaPago}
                            disabled={!nuevaFormaPago || loadingFormasPago}
                        >
                            OK
                        </Button>
                        <Button
                            variant="secondary"
                            size="sm"
                            onClick={() => { setSeleccionarFormaPago(false); setNuevaFormaPago(''); }}
                            className="ms-2"
                        >
                            Cancelar
                        </Button>
                    </>
                }
            </>}
        </Col>
    );
};

OrdenFormaPago.propTypes = {
    loadingInfoDetallesOrden: PropTypes.bool.isRequired,
    orden: PropTypes.object.isRequired,
    setOrden: PropTypes.func.isRequired,
    seleccionarFormaPago: PropTypes.bool.isRequired,
    setSeleccionarFormaPago: PropTypes.func.isRequired,
    nuevaFormaPago: PropTypes.string.isRequired,
    setNuevaFormaPago: PropTypes.func.isRequired,
    onComentarioAgregado: PropTypes.func
};

export default OrdenFormaPago;